import { values } from './_helpers'

const _enum = {
  immediateSell: 0,
  longTermStock: 1,
  aging: 2,
  investment: 3
}

const holdingStrategy = { ..._enum, name: 'holdingStrategy', values: values(_enum) }

export {
  holdingStrategy
}
